module.exports = __webpack_public_path__ + "img/skyknow.72dafda5.png";